import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { SettingsButton } from "~/components/AssetModalV2/Content/Footer/components/SettingsButton";
import { useImageContentControlsContext } from "~/components/AssetModalV2/Content/ImageContentControlsContextProvider";
import { SelectedOptionIcon } from "~/components/AssetModalV2/Visualizer/VideoVisualizer/VideoVisualizerInner/shared/SelectedOptionIcon";
export const ImageSettingsButton = /*#__PURE__*/ memo(()=>{
    const { showOriginal, setShowOriginal } = useImageContentControlsContext();
    const options = useMemo(()=>[
            {
                label: "Show image transparency",
                onSelect: ()=>setShowOriginal(!showOriginal),
                id: "show-original",
                suffix: showOriginal ? /*#__PURE__*/ _jsx(SelectedOptionIcon, {}) : null,
                type: "item",
                truncate: false
            }
        ], [
        showOriginal,
        setShowOriginal
    ]);
    return /*#__PURE__*/ _jsx(SettingsButton, {
        options: options,
        "data-testid": "IMAGE_SETTINGS_BUTTON"
    });
});
ImageSettingsButton.displayName = "ImageSettingsButton";
